import React, { PureComponent } from "react";
import {
  GridRow,
  GridColumn,
  Button,
  Carousel,
  Img,
} from "arv-reactcomponents";
import { CORPORATE_GIFTING_COMPONENTS, Endpoints } from "npmlinks-constants";

class CommendationCarousel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };

    this.items = CORPORATE_GIFTING_COMPONENTS.COMMENDATIONCAROUSEL_ITEMS;

    this.renderItems = this.renderItems.bind(this);
    this.setParent = this.setParent.bind(this);
    this.onSwipe = this.onSwipe.bind(this);
  }

  setIndex(index) {
    this.setState({
      index,
    });
  }

  onSwipe(direction) {
    this.scroll(direction.horizontal);
  }

  scroll(type, event) {
    if (event) event.preventDefault();
    const { index } = this.state;
    const newIndex = type === "next" ? index + 1 : index - 1;
    if (newIndex > -1 && newIndex < this.items.length) {
      this.setIndex(newIndex);
    }
  }

  setParent() {
    const [carouselContainer] = document.querySelectorAll(
      ".nw-carouselexample",
    );

    this.carouselContainer = carouselContainer;
  }

  renderItems(item, index) {
    return (
      <div
        key={item.id}
        role="presentation"
        className="nw-carouselexample-item"
      >
        <GridRow className="wc-commendationcarousel-brand">
          {console.log(this.items.length)}
          <GridColumn className="nwc-grid-col-sm-2 wc-commendationcarousel-imagecontainer">
            <Img
              src={item.brandLogo || Endpoints.noImg}
              className="wc-commendationcarousel-image"
              alt="No Image Found"
            />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-10">
            <div className="wc-commendationcarousel-brandname">{item.id}</div>
            <div className="wc-commendationcarousel-brandtext">
              {item.brandText}
            </div>
          </GridColumn>
        </GridRow>
      </div>
    );
  }

  render() {
    const { index } = this.state;

    const nextIndex = index + 1;
    const limitNextIndex = nextIndex >= this.items.length ? index : nextIndex;

    const prevIndex = index - 1;
    const limitPrevIndex = prevIndex < 0 ? index : prevIndex;

    return (
      <div className="wc-commendationcarousel-container">
        <div className="wc-commendationcarousel-btncontainer">
          {this.items.length !== 1 && (
            <Button
              disabled={index === 0}
              className="nwc-btn-primary-txt wc-commendationcarousel-btn-left"
              onClick={() => {
                this.setIndex(limitPrevIndex);
              }}
            >
              <i className="icomoon-arrow_left wc-commendationcarousel-icomoon" />
            </Button>
          )}
        </div>
        <div className="wc-commendationcarousel-carouselcontainer">
          <Carousel
            className="nw-carouselexample"
            index={index}
            items={this.items}
            renderItems={this.renderItems}
            onSwipe={this.onSwipe}
          />
        </div>
        <div className="wc-commendationcarousel-btncontainer">
          {this.items.length !== 1 && (
            <Button
              disabled={index === this.items.length - 1}
              className="nwc-btn-primary-txt wc-commendationcarousel-btn-right"
              onClick={() => {
                this.setIndex(limitNextIndex);
              }}
            >
              <i className="icomoon-arrow_right wc-commendationcarousel-icomoon" />
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default CommendationCarousel;
